import React from 'react';
import createHistory from 'history/createBrowserHistory';
import {Card, CardActions} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import Print from 'material-ui/svg-icons/action/print';

class Receipt extends React.Component {
  constructor(props) {
    super(props);
    const {saleKey} = this.props.match.params;
    this.initialState = {
      shopkeeperInfo: '',
      saleKey,
      sale: {
        vat: '',
        paidAt: '',
        key: '',
        price: '',
        productName: ''
      }
    };

    this.state = {
      ...this.initialState
    };
  }

  componentDidMount = () => {
    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;
    firebase.database().ref(`shopkeepers/${shopkeeperId}/info`).once('value').then((data) => {
      this.setState({shopkeeperInfo: data.val()});
    });
    firebase.database().ref(`shopkeepers/${shopkeeperId}/sales/${this.state.saleKey}`).once('value').then((data) => {
      const sale = {
        key: data.key,
        ...data.val()
      };
      this.setState({sale});
    });
  }
  handlePrint = () => {
    window.print();
  }
  render() {
    const {t, user} = this.props;

    return (
      <Card className='cardStyle' >
        <Toolbar>
          <ToolbarGroup firstChild={true}>
            <IconButton onTouchTap={createHistory().goBack}>
              <ArrowBack color="rgba(0,0,0,0.4)" />
            </IconButton>
            <ToolbarTitle text={t('receipt.receipt')}/>
          </ToolbarGroup>
        </Toolbar>
              <Grid fluid>
                <Row style={{padding: 10}}>
                  <Col xs>
                        {this.state.shopkeeperInfo.name}
                        <br />
                        {this.state.shopkeeperInfo.address}
                        <br />
                        {t('receipt.phone')}
                        {this.state.shopkeeperInfo.phoneNumber}
                        <br />
                        {t('receipt.companyId')}
                        {this.state.shopkeeperInfo.companyId}
                  </Col>
                  <Col style={{textAlign: 'right'}} xs>
                        {t('receipt.paidAt')}
                        {new Date(this.state.sale.paidAt).toLocaleString(user.language)}
                        <br />
                        {t('receipt.orderNumber')}
                        {this.state.sale.key}
                  </Col>
                </Row>
                <Divider />
                <Table style={{tableLayout: 'auto'}} selectable={false}>
                  <TableBody displayRowCheckbox={false}>
                    <TableRow>
                      <TableRowColumn style={{color: '#9e9e9e'}}>{t('product.product')}</TableRowColumn>
                      <TableRowColumn style={{color: '#9e9e9e', textAlign: 'right'}}>{t('receipt.priceExcludeVat')}</TableRowColumn>
                      <TableRowColumn style={{color: '#9e9e9e', textAlign: 'right'}}>{t('receipt.vatEuro')}</TableRowColumn>
                      <TableRowColumn style={{color: '#9e9e9e', textAlign: 'right'}}>{t('receipt.vat')}</TableRowColumn>
                      <TableRowColumn style={{color: '#9e9e9e', textAlign: 'right'}} >{t('price')}</TableRowColumn>
                    </TableRow>
                    <TableRow>
                      <TableRowColumn style={{whiteSpace: 'normal',
                        wordWrap: 'break-word'}}>{this.state.sale.productName}</TableRowColumn>
                      <TableRowColumn style={{textAlign: 'right'}}>{this.state.sale.priceExcludeVat + ' €'}</TableRowColumn>
                      <TableRowColumn style={{textAlign: 'right'}}>{this.state.sale.vatInEuro + ' €'}</TableRowColumn>
                      <TableRowColumn style={{textAlign: 'right'}}>{this.state.sale.vat || 0 }</TableRowColumn>
                      <TableRowColumn style={{textAlign: 'right'}}>{this.state.sale.price  + ' €'}</TableRowColumn>
                    </TableRow>
                  </TableBody>
                </Table>
                <CardActions>
                  <RaisedButton
                    label={t('print')}
                    primary
                    icon={<Print />}
                    onTouchTap={this.handlePrint} />
                </CardActions>
              </Grid>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(Receipt);



// WEBPACK FOOTER //
// ./src/Sale/Receipt.js